module.exports = __webpack_public_path__ + "static/media/bank-bank-font-cta-pressed.052931d6.png";